import { Injectable, inject } from '@angular/core';
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  UrlTree,
  Router,
} from '@angular/router';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AccessDeniedGuard implements CanActivate {
  private router = inject(Router);


  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
      const options = this.router.currentNavigation()?.extras;
      if (options?.skipLocationChange) {
        return true;
      }

      const url = this.router.parseUrl(state.url);
      this.router.navigateByUrl(url , {...options, skipLocationChange: true})
      return false;
  }
}
